import { Injectable, signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import type { DeviceIdentityModel, DeviceTwinModel, DirectMethodResponse, C2DSendResponse, TelemetryMessage, TelemetryResponse } from './device.service';
import { 
  setCurrentDevice, 
  loadIdentitySuccess, 
  loadTwinSuccess, 
  updateConnectionState,
  loadIdentity,
  loadIdentityFailure
} from '../store/device/device.actions';

@Injectable({ providedIn: 'root' })
export class DeviceDataStore {
  private ngrxStore = inject(Store);
  
  deviceId = signal<string | null>(null);
  iotHubName = signal<string | null>(null);
  identity = signal<DeviceIdentityModel | null>(null);
  twin = signal<DeviceTwinModel | null>(null);
  loading = signal<boolean>(false);
  error = signal<string | null>(null);
  directMethodResult = signal<DirectMethodResponse | null>(null);
  connectionState = signal<'Connected' | 'Disconnected' | null>(null);

  
  c2dResult = signal<C2DSendResponse | null>(null);
  c2dSending = signal<boolean>(false);
  c2dError = signal<string | null>(null);

  
  telemetryMessages = signal<TelemetryMessage[]>([]);
  telemetryLoading = signal<boolean>(false);
  telemetryError = signal<string | null>(null);



  setDeviceId(id: string) { 
    this.deviceId.set(id); 
    // Sync to NgRx Store
    this.ngrxStore.dispatch(setCurrentDevice({ deviceId: id }));
  }

  setIotHubName(name: string | null) {
    this.iotHubName.set(name);
  }
  
  setIdentity(v: DeviceIdentityModel | null) { 
    this.identity.set(v); 
    // Sync to NgRx Store
    if (v) {
      this.ngrxStore.dispatch(loadIdentitySuccess({ identity: v }));
    }
  }
  
  setTwin(v: DeviceTwinModel | null) { 
    this.twin.set(v); 
    // Sync to NgRx Store
    if (v) {
      this.ngrxStore.dispatch(loadTwinSuccess({ twin: v }));
    }
  }
  
  setLoading(v: boolean) { 
    this.loading.set(v); 
    // Sync to NgRx Store - dispatch loadIdentity when starting
    if (v && this.deviceId()) {
      this.ngrxStore.dispatch(loadIdentity({ deviceId: this.deviceId()! }));
    }
  }
  
  setError(v: string | null) { 
    this.error.set(v); 
    // Sync to NgRx Store
    if (v) {
      this.ngrxStore.dispatch(loadIdentityFailure({ error: v }));
    }
  }
  
  setDirectMethodResult(v: DirectMethodResponse | null) { this.directMethodResult.set(v); }
  
  setConnectionState(v: 'Connected' | 'Disconnected' | null) { 
    this.connectionState.set(v); 
    // Sync to NgRx Store
    if (v) {
      this.ngrxStore.dispatch(updateConnectionState({ connectionState: v }));
    }
  }

  
  setC2DResult(v: C2DSendResponse | null) { this.c2dResult.set(v); }
  setC2DSending(v: boolean) { this.c2dSending.set(v); }
  setC2DError(v: string | null) { this.c2dError.set(v); }

  
  setTelemetryMessages(v: TelemetryMessage[]) { this.telemetryMessages.set(v); }
  setTelemetryLoading(v: boolean) { this.telemetryLoading.set(v); }
  setTelemetryError(v: string | null) { this.telemetryError.set(v); }

}
